import Layout from '../components/Layout'
import { PageHeader, Section, Card } from '../components/UIComponents'
import { useUser, SignOutButton } from '@clerk/clerk-react'

export default function Profile() {
  const { user } = useUser()

  return (
    <Layout>
      <div className="space-y-8 max-w-4xl mx-auto">
        <PageHeader
          icon="👤"
          title="Perfil"
          description="Gestiona tu información personal"
        />

        <Section title="Información Personal">
          <Card>
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                {user?.profileImageUrl && (
                  <img
                    src={user.profileImageUrl}
                    alt={user.firstName || 'User'}
                    className="w-16 h-16 rounded-lg"
                  />
                )}
                <div>
                  <p className="text-white font-semibold text-lg">
                    {user?.firstName} {user?.lastName}
                  </p>
                  <p className="text-slate-400 text-sm">
                    {user?.emailAddresses[0]?.emailAddress}
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </Section>

        <Section title="Configuración de Cuenta">
          <Card>
            <div className="space-y-3">
              <div className="flex items-center justify-between p-3 bg-slate-800/50 rounded-lg">
                <span className="text-slate-300">Notificaciones</span>
                <input type="checkbox" className="w-4 h-4" defaultChecked />
              </div>
              <div className="flex items-center justify-between p-3 bg-slate-800/50 rounded-lg">
                <span className="text-slate-300">Autenticación de dos factores</span>
                <button className="text-blue-400 text-sm font-semibold">Activar</button>
              </div>
            </div>
          </Card>
        </Section>

        <Section title="Acciones">
          <SignOutButton>
            <button className="w-full px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors">
              Cerrar Sesión
            </button>
          </SignOutButton>
        </Section>
      </div>
    </Layout>
  )
}
